<div
  class="menu"
  [style.background-color]="theme.getColor('Sidebar Dark')"
>
  <!-- Dashboard -->
  <a
    routerLink="/core/dashboard"
    class="menu-link"
  >
    <div
      class="section"
      [style.background-color]="theme.getColor('Sidebar Dark')"
      [class.current]="router.url.includes('/core/dashboard')"
    >
      <div class="material-icons md-48">
        dashboard
      </div>

      <p>Dashboard</p>
    </div>
  </a>

  <!-- Domaines applicatifs -->
  <a
    routerLink="/core/service-management"
    class="menu-link"
  >
    <div
      class="section"
      [style.background-color]="theme.getColor('Sidebar Dark')"
      [class.current]="router.url.includes('/core/service-management')"
    >
      <div class="material-icons md-48">
        storage
      </div>

      <p>Domaines Applicatifs</p>
    </div>
  </a>

  <!-- Données collectées -->
  <a
    routerLink="/core/data"
    class="menu-link"
    [ngStyle]="isCollectedDataTabHidden() ? {'display': 'none'} : {}"
  >
    <div
      class="section"
      [style.background-color]="theme.getColor('Sidebar Dark')"
      [class.current]="router.url.includes('/core/data')"
    >
      <div class="material-icons md-48">
        source
      </div>

      <p>Données collectées</p>
    </div>
  </a>

  <!-- Facturation -->
  <a
    routerLink="/core/facturation"
    class="menu-link"
    [ngStyle]="isFacturationHidden() ? {'display': 'none'} : {}"
  >
    <div
      class="section"
      [style.background-color]="theme.getColor('Sidebar Dark')"
      [class.current]="router.url.includes('/core/facturation')"
    >
      <div class="material-icons md-48">
        library_books
      </div>

      <p>Facturation</p>
    </div>
  </a>

  <!-- Administration -->
  <a
    routerLink="/core/admin"
    class="menu-link"
    [ngStyle]="!isAdministrationTabShowable() ? {'display': 'none'} : {}"
  >
    <div
      class="section"
      [style.background-color]="theme.getColor('Sidebar Dark')"
      [class.current]="router.url.includes('/core/admin')"
    >
      <div class="material-icons md-48">
        settings
      </div>

      <p>Administration</p>
    </div>
  </a>

  <!-- Guide d'utilisation -->
  <button
    type="button"
    class="menu-link guide-button"
    (click)="openGuide('userGuide')"
  >
    <div
      class="section"
      [style.background-color]="theme.getColor('Sidebar Dark')"
    >
      <div class="material-icons md-48">
        help
      </div>

      <p>Guide d'utilisation</p>
    </div>
  </button>
</div>

<br>
<br>